import { useMemo } from "react";
import "../../../style/leavetabcommon.css";
import { useHistory } from "react-router-dom";
export default function LeaveBalance({ leaveList = [], tasks = [] }) {
  const history = useHistory(); // ✅ MUST be here (top level)

  /* -------------------- GENERAL LEAVE MASTER -------------------- */
  const glData = useMemo(() => {
    return leaveList.find(
      leave =>
        leave.leaveTypeId === 68 ||
        leave.type?.includes("General Leave")
    );
  }, [leaveList]);

  /* -------------------- CURRENT MONTH LEAVE COUNT -------------------- */
  const currentMonthTaken = useMemo(() => {
    const now = new Date();
    const currentMonth = now.getMonth(); // 0-based
    const currentYear = now.getFullYear();
 
    return tasks.reduce((total, task) => {
      if (!task.date) return total;

      const taskDate = new Date(task.date);

      const isCurrentMonth =
        taskDate.getMonth() === currentMonth &&
        taskDate.getFullYear() === currentYear;

      if (!isCurrentMonth) return total;

      // 🔹 Full day = 1, Half day = 0.5
      if (task.dayType === "HALF" || task.isHalfDay) {
        return total + 0.5;
      }

      return total + 1;
    }, 0);
  }, [tasks]);
 const handleClick = () => {
    history.push("/ApplyMyLeaves");
  };
  if (!glData) {
    return (
      <div className="card leave-balance">
        <h5>
          Leave Balance <span className="muted">this month</span>
        </h5>
        <p className="text-muted">No General Leave data available</p>
      </div>
    );
  }

  const {
    leaveBalance,
    noOfLeavesPerYear
  } = glData;

  const percent =
    noOfLeavesPerYear > 0
      ? (currentMonthTaken / noOfLeavesPerYear) * 100
      : 0;

  return (
    <div className="card leave-balance">
    <div className="d-flex align-items-start gap-3 mb-3">

  {/* Icon */}
  <div className="icon-box bg-warning-light">
    <i className="fas fa-calendar-check text-warning"></i>
  </div>

  {/* Title + Subtitle */}
  <div>
    <h5 className="mb-1 fw-semibold">
      Leave Balance This Month (GL)
    </h5>
    <p className="text-muted small mb-0">
      General leave balance summary
    </p>
  </div>

</div>

      <div className="balance-row">
        <div>
          <p className="label">Leave Taken</p>
          <p className="value">
            {currentMonthTaken} Days
          </p>
        </div>

        <div className="right">
          <p className="label">Remaining</p>
          <p className="value">
            {leaveBalance} Days
          </p>
        </div>
      </div>

      <div className="progress">
        <div
          className="progress-fill"
          style={{ width: `${percent}%` }}
        />
      </div>

      <div className="total-text">
        Total: {noOfLeavesPerYear} Days / Year
      </div>
<br/>
      <button className="primary-btn" onClick={handleClick}>
        Request Leave
      </button>
    </div>
  );
}
